module.exports = __webpack_public_path__ + "img/text.21725541.svg";